// Hard-to-guess private entry path for the admin/team portal.
// Share this link only with people who should get access.
export const ADMIN_BASE = "/team-a7k2x9";
